module.exports = __webpack_public_path__ + "static/media/logo-removebg-preview.f3f0bbed.png";